import * as actions from "./EventActions";
import { initialEventState, EventState } from "./EventState";
import buildReducer from "../../utils/ReducerBuilder";

export const EventReducer = buildReducer<EventState>(initialEventState)
    .handle(actions.onSubscribedRsvpUpdated, (state, action) => {
        const subscribedRsvpUpdatedOn = { ...state.subscribedRsvpUpdatedOn };
        subscribedRsvpUpdatedOn[action.payload || 0] = new Date().valueOf();

        return {
            ...state,
            subscribedRsvpUpdatedOn,
        };
    })
    .handle(actions.onSubscribedToRsvpUpdates, (state, action) => {
        const subscribedToRsvpUpdates = { ...state.subscribedToRsvpUpdates };
        subscribedToRsvpUpdates[action.payload!.eventId] = action.payload!.subscribed;

        return {
            ...state,
            subscribedToRsvpUpdates,
        };
    })
    .handle(actions.onWebsocketUpdated, (state, action) => ({
        ...state,
        websocket: action.payload,
    }))
    .done();



// WEBPACK FOOTER //
// ./src/store/event/EventReducer.ts